import { useState, useCallback, useContext } from 'react';
import { triggerOracleSync } from '../../../../api/index';
import { useAuthToken } from '../../../../hooks/AuthHook';
import { AdminStateContext } from '../../../../providers/AdminStateProvider.jsx';

/**
 * Hook to trigger Oracle ERP sync with movement IDs
 * Returns loading/error states and the trigger function
 */
export const useOracleSyncTrigger = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);
    const authToken = useAuthToken();
    const [adminState] = useContext(AdminStateContext);
    const { country } = adminState;

    const triggerSync = useCallback(async (movementIds) => {
        if (!authToken || !country) {
            setError('No se pudo autenticar. Intenta recargar la página.');
            return null;
        }

        if (!movementIds || movementIds.length === 0) {
            setError('Debes ingresar al menos un movement ID.');
            return null;
        }

        setLoading(true);
        setError(null);
        setResult(null);

        try {
            const response = await triggerOracleSync(country, authToken, movementIds);
            setResult(response);
            return response;
        } catch (err) {
            console.error('Error triggering Oracle sync:', err);
            const errorMessage = err.message || 'Error al iniciar la sincronización. Intenta nuevamente.';
            setError(errorMessage);
            return null;
        } finally {
            setLoading(false);
        }
    }, [country, authToken]);

    const reset = useCallback(() => {
        setError(null);
        setResult(null);
    }, []);

    return {
        triggerSync,
        loading,
        error,
        result,
        reset
    };
};
